import React from 'react';
import PropTypes from 'prop-types';
import Time from 'react-time';

import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

const UserListItem = (props) => {
  return (
    <TableRow hover>
      {
        [props.email, props.role].map((item, idx) => {
          return (
            <TableCell key={idx} align='center' style={{ height: 48 }}>{item}</TableCell>
          );
        })
      }
      <TableCell align='center'>
        <Time value={props.created_ts} format="YYYY-MM-DD HH:mm" />
      </TableCell>     
    </TableRow>    
  );
};

UserListItem.propTypes = {
  email: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  created_ts: PropTypes.string.isRequired,
  updated_ts: PropTypes.string.isRequired
};

export default React.memo(UserListItem);
